import React from "react";
import { genURL, gengetURLTEST, genpostURL, genpostURLTEST, genURLTEST } from './../_getjson';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Row, Grid, Col, Panel } from "react-bootstrap";

import PopupArcode from './../PopUp/PopUpArcode';
import PopUptable from './../PopUp/PopUpListINCOME';
import PopUpOther3 from './../PopUp/PopUpDeposit';
import PopUpOther from './../PopUp/PopUpOther';
import PopUpOtherDB from "../PopUp/PopUpOther";
import { parseJwt } from '../parseJWT';
import PopUpSaveMoneyExp from './../PopUp/PopUpSaveMoneyExp';
import PopUpSearchDoc from '../PopUp/PopUpSearch_debtor';
import PopUpReport from './../PopUp/_fromShow';
import { department, branch } from '../_source/checkUnit';
import axios from 'axios'
import Backdrop from './../Components/CustomBackdrop/Barckdrop'
import Checkdocgroup from './../CustomFunction/Docgroup/Checkdocgroup'
import Chackdocno from './../CustomFunction/Docno/GetDocno'
import ChackAr from './../CustomFunction/Csar/GetAr'
import CheckUser from './../CustomFunction/Csuser/GetUser'
import CheckBrabchname from './../CustomFunction/Branch/Checkname'
import CheckDepartmentname from './../CustomFunction/Department/Checkname'
import Snackbar from './../Components/Snackbar/Snackbar'
import ErrorIcon from '@mui/icons-material/ErrorOutlineRounded';
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import CheckTaxrate from './../CustomFunction/Docgroup/CheckTaxrate'
// import FullScreenDialog from "./../PopUp/FullScreendialogs"
import SelectDatas from "./../PopUp/SelectData"
import MaterialUIPickers from "./../Components/CustomDatepicker/MaterialUIPickers"
import Topbar from "../Components/Customtopbar/Topbar";
import FullScreenDialog from '../PopUp/FullScreendialogs/FullScreen'
import PopUpMultipletax from './../PopUp/PopUpMultipletax'
import Rechecked from "./Components/Rechecked";
import CheckTaxgroup from "./../CustomFunction/Docgroup/CheckTaxgroup";
import CheckCodeDocGroup from "../CustomFunction/Docgroup/CheckCodeDocGroup";

const listMenu = [["บันทึกใบกำกับภาษีหลายใบ", "Inputmultipletax"],
["บันทึกจ่ายเงิน", "Payrecord"]]
const defaultcode = '0';
const Checktxt = (value) => {
    var data = value ? value : ""
    return data
}
const tablename = "CSARCNDEPOSIT"
export default class Index extends React.Component {
    constructor(props) {
        super(props);
        this.CustomerCode = React.createRef();
        this.CustomerName = React.createRef();
        this.Groupdata_code = React.createRef();
        this.Groupdata = React.createRef();
        this.DeliNumber = React.createRef();
        this.TAXNO = React.createRef();
        this.Remark = React.createRef();
        this.Depositno = React.createRef();
        this.Department_code = React.createRef();
        this.Department = React.createRef();
        this.Branch_code = React.createRef();
        this.Branch = React.createRef();
        this.Csuser_code = React.createRef();
        this.Csuser = React.createRef();
        this.Currency = React.createRef();
        this.Totalamount = React.createRef();
        this.Sumamount1 = React.createRef();
        this.Sumamount2 = React.createRef();
        this.Beforetax = React.createRef();
        this.Taxrate = React.createRef();
        this.Taxamount = React.createRef();
        this.Debtamount = React.createRef();
        this.Round_PAY = React.createRef();
        this.state = {
            SwitchPopupArcode: false,
            openFullScreenDialog: false,
            showPopupOT3: false,
            ARCode: "",
            tableData: [],
            data1: "",
            selectRow: [],
            DocType: [],
            SGstatus: true,
            DisInput: true,
            mstremark: '-',
            tfdocPrint: "",
            CHLOOP: 0,
            loading: "none",
            Currencycode: "บาท",
            rowtb: "300",
            SiteCode_txt: "",
            Department_txt: "",
            Branch_txt: "",
            Groupdata_txt: "",
            CSdelete: "",
            CSdeletes: false,
            CSdelete_yes: false,
            AmountPayable: 0,
            Uststus: true,
            openBackdrop: false,
            autoClose: 3600,
            color: "warning",
            messagealert: "",
            siteCodeUser1: "",
            dataMultipletax: "",
            multipletax: [],
            Docdate1: "",
            Groupcode: "",
            Groupname: "",
            Docno: "",
            Remark: "",
            PROJECT: "",
            PriceType_code: defaultcode,
            defaultselect: defaultcode,
            checkenableInput: [],
            taxgroup: "",
            recheckeddata: [],
            Docdate: ""
        }
    }
    async componentDidMount() {
        //เช็คเปิดปิด textbox 
        await this.setState({
            checkenableInput: JSON.parse(localStorage.getItem('checkoftxt'))
        })
        let SITECODESTR = parseJwt(localStorage.getItem('Token'));
        this.setState({ siteCodeUser: SITECODESTR.User.SITECODE });
        this.setState({ siteCodeUser1: SITECODESTR.User.CODE });
        this.Sumamount1.current.value = 0.00;
        this.setdelete_load()
        this.setRow(this.state.rowtb);
        this.Get_UserCode(localStorage.getItem("Username"));
        this.onAddValue("Csuser", SITECODESTR.User.CODE)
        this.setState({ userCode: SITECODESTR.User.CODE })
        this.Currency.current.value = "บาท"
        this.onAddValue("Branch", SITECODESTR.User.SITECODE);
        this.Round_PAY.current.value = Number("0").toFixed(2)

    }
    get_PopUpSaveMoney = async (
        cash, cchqsarr, csrexpensesarr, csrecincomarr
        // data1, data2, data3, data4, Credit, Creditsum, Income, Incomesum, Expenses, Expensessum
    ) => {
        this.CloseDialog(false)
        let Cchqssum = 0
        let Expensessum = 0
        let Incomesum = 0
        cchqsarr.forEach(element => {
            Cchqssum += Number(element.Chqamount)
        });
        csrexpensesarr.forEach(element => {
            Expensessum += Number(element.Expensesamount)
        });
        csrecincomarr.forEach(element => {
            Incomesum += Number(element.IncomeAmount)
        });
        await this.setState({
            CashReceipt: cash[0].Cashbalance,//เงินสด
            Bookno: cash[0].Bookno, //เลขบัญชี
            Bankamount: cash[0].Bankamount, //ยอดเงินโอน
            Bankexpend: cash[0].Bankexpend, //ค่าธรรมเนียมจ่ายหักบัญชี
            Bookdesc: cash[0].Transferremark,
            Expenses: csrexpensesarr,
            Expensessum: Expensessum,
            Advanceamount: cash[0].Advanceamount,
            Pettycashcode: cash[0].Pettycashcode,
            Pettycash: cash[0].Pettycashvalue,
            cchqssum: Cchqssum,
            cchqs: cchqsarr,
            Income: csrecincomarr,
            Incomesum: Incomesum
        })

        await this._saveConnection()
    }
    _saveConnection = async () => {
        var table = this.state.tableData
        var btnt = '0'
        for (var i = 0; i < table.length && table[i].T_Code; i++) {
            if (table[i].BTN_T === "1") {
                btnt = '1'
            }
            if (table[i].T_Code && table[i].T_Department_Code === "") {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณากรอกแผนก...!" })
                return
            }
        }


        var row = this.state.multipletax
        if (row) {
            var total = ""
            for (let i = 0; i < row.length && row[i].Taxno; i++) {
                total += Number(row[i].Totalamount)
            }
            var parmtotal = Number(this.Totalamount.current.value)
            console.log(Number(total), "===", parmtotal);
            // if (Number(total) !== parmtotal) {
            //     this.setState({ opensnackbar: true })
            //     this.setState({ color: "warning" })
            //     this.setState({ icon: ErrorIcon })
            //     this.setState({ messagealert: "มูลค่าภาษีขายไม่เท่ากับหน้าบิลขาย" })
            //     return
            // }
        }

        if (this.state.tableData.length === 0) {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณาเลือกรายการ" })
            this.setState({ Uststus: false });
            return;
        } else if (this.CustomerCode.current.value === "") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณากรอกรหัสลูกค้า" })
            this.setState({ Uststus: false });
            return;
        } else if (this.Groupdata_code.current.value === "") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณาเลือกกลุ่มข้อมูล" })
            this.setState({ Uststus: false });
            return;
        } else if (this.Department_code.current.value === "") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณาเลือกแผนก" })
            this.setState({ Uststus: false });
            return;
        } else if (this.Branch_code.current.value === "") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณาเลือกสาขา" })
            this.setState({ Uststus: false });
            return;
        } else if (this.Taxrate.current.value === "0.00" && this.state.PriceType_code !== "2") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณากรอกภาษีมูลค่าเพิ่มก่อน" })
            return;
        } else if (this.state.multipletax.length < 1 && btnt === "1") {

            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณากรอกภาษีมูลหลายใบ..." })
            return;
        } else if (this.Round_PAY.current.value === "") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณากรอกรอบที่" })
            this.Round_PAY.current.focus()
            return
        } else if (this.Depositno.current.value === "") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณาเลือกใบรับเงินมัดจำ" })
            this.Round_PAY.current.focus()
            return
        } else {

            let chkmuney = (Number(this.state.CashReceipt) +
                Number(this.state.Advanceamount) +
                Number(this.state.Pettycash) +
                Number(this.state.Bankamount) +
                Number(this.state.Incomesum) +
                Number(this.state.cchqssum)) -
                (Number(this.state.Bankexpend) +
                    Number(this.state.Expensessum))

            console.log("Debtamount", this.Debtamount.current.value,
                "CashReceipt", this.state.CashReceipt,
                "Advanceamount", this.state.Advanceamount,
                "Pettycash", this.state.Pettycash,
                "Bankamount", this.state.Bankamount,
                "Incomesum", this.state.Incomesum,
                "cchqssum", this.state.cchqssum,
                "Bankexpend", this.state.Bankexpend,
                "Expensessum", this.state.Expensessum,
                "chkmuney", chkmuney)

            if (chkmuney === Number(this.Debtamount.current.value)) {
                // console.log(this.state.Advanceamount)
                // return
                await this.setState({ Uststus: true })
                await this.saveData()
            } else {
                await this.openDialog("Payrecord")
            }
        }
    }
    saveData = async (
        // cash, cchqsarr, csrexpensesarr, csrecincomarr
        //  CashReceipt, CashReceipt2, CashReceipt3, CashReceipt4, Bookno, Bankamount, Bankexpend, data3, data4, _BOOKDESC, CashReceipt33, Credit, Creditsum, Income, Incomesum, Expenses, Expensessum
    ) => {
        console.log("saveData")
        const parameter = new URLSearchParams();
        parameter.append("JWT", localStorage.getItem('Token'))
        var tableData = [];
        var items = [];
        for (var i = 0; i < this.state.tableData.length && this.state.tableData[i].T_Code; i++) {
            tableData[i] = {
                T_Code: this.state.tableData[i].T_Code,
                T_List: this.state.tableData[i].T_List,
                T_Explain: this.state.tableData[i].T_Explain,
                T_Amount: this.state.tableData[i].T_Amount,
                T_Department_Code: this.state.tableData[i].T_Department_Code,
                T_Branch_Code: this.state.tableData[i].T_Branch_Code,
                BTN_T: this.state.tableData[i].BTN_T,
                projectcode: this.state.tableData[i].PROJECT ? this.state.tableData[i].PROJECT : ""
            }
            items.push(tableData[i]);
        }
        let code = this.Groupdata_code.current.value.substring(0, 2)
        parameter.append("CSPAYCHQ", !this.state.cchqs ? "" : JSON.stringify(this.state.cchqs));
        parameter.append("CSRECINCOME", !this.state.Income ? "" : JSON.stringify(this.state.Income));
        parameter.append("CSRECEXPENSE", !this.state.Expenses ? "" : JSON.stringify(this.state.Expenses));
        parameter.append("listitem", JSON.stringify(items));
        var row = this.state.multipletax

        // เตรียม inputtax เพื่อส่งไปบันทึก    
        let Multipletaxitem = []
        let Multipletaxdata = []
        for (let i = 0; i < this.state.multipletax.length; i++) {
            if (this.state.multipletax[i].Taxno) {
                Multipletaxitem[i] = {
                    Arcode: this.state.multipletax[i].Arcode,
                    Arname: this.state.multipletax[i].Arname,
                    Beforetax: this.state.multipletax[i].Beforetax,
                    Code: this.state.multipletax[i].Code,
                    Remark: this.state.multipletax[i].Remark,
                    Taxamount: this.state.multipletax[i].Taxamount,
                    Taxdate: this.state.multipletax[i].Taxdate,
                    Taxno: this.state.multipletax[i].Taxno,
                    Totalamount: this.state.multipletax[i].Totalamount,
                    Zerotax: this.state.multipletax[i].Zerotax
                }
                Multipletaxdata.push(Multipletaxitem[i]);
            }
        }
        parameter.append("Multipletax", !Multipletaxdata ? "" : JSON.stringify(Multipletaxdata));
        parameter.append("CREATEUSER", localStorage.getItem('Username'));
        parameter.append("DOCNO", this.DeliNumber.current.value);
        parameter.append("REMARK", Checktxt(this.Remark.current.value));
        parameter.append("ARCODE", this.CustomerCode.current.value);
        parameter.append("ARNAME", this.CustomerName.current.value);
        parameter.append("DEPOSITNO", this.Depositno.current.value);
        parameter.append("DOCGROUP", this.Groupdata_code.current.value);
        parameter.append("TAXTYPE", this.state.PriceType_code);
        parameter.append("DEPARTMENT", this.Department_code.current.value);
        parameter.append("SITECODE", this.Branch_code.current.value);
        parameter.append("SUMAMOUNT2", this.Sumamount2.current.value);
        parameter.append("DEBTAMOUNT", this.Debtamount.current.value);
        parameter.append("EXCHANGERATE", "1.0000000");
        parameter.append("CURRENCYCODE", "TH");
        parameter.append("BANKAMOUNT", this.state.Bankamount);
        parameter.append("DOCDATE", this.state.Docdate);
        parameter.append("BOOKNO", this.state.Bookno);
        parameter.append("BANKEXPEND", this.state.Bankexpend);
        parameter.append("BOOKDESC", this.state.Bookdesc)
        parameter.append("COMPUTERNAME", "COMPUTERNAME")
        parameter.append("CASHAMOUNT", this.state.CashReceipt);
        parameter.append("PETTYCASHCODE", typeof this.state.Pettycashcode !== "undefined" ? this.state.Pettycashcode : "");
        parameter.append("PETTYCASH", typeof this.state.Pettycash !== "undefined" ? this.state.Pettycash : "");

        parameter.append("INCOMEAMOUNT", typeof this.state.Incomesum !== "undefined" ? this.state.Incomesum : "0");
        parameter.append("EXPENDAMOUNT", typeof this.state.Expensessum !== "undefined" ? this.state.Expensessum : "0");
        /* Still left */
        parameter.append("PROJECT", this.state.PROJECT)
        parameter.append("SUMAMOUNT1", this.Sumamount1.current.value);
        parameter.append("TAXRATE", this.Taxrate.current.value);
        parameter.append("TAXAMOUNT", this.Taxamount.current.value);
        parameter.append("TOTALAMOUNT", this.Totalamount.current.value);
        parameter.append("BATHSUMAMOUNT1", Number(this.Totalamount.current.value - this.Taxamount.current.value));
        parameter.append("Round_PAY", this.Round_PAY.current.value ? Number(this.Round_PAY.current.value).toFixed(2) : "");
        parameter.append("ADVANCEPAYBAL", typeof this.state.Advanceamount !== "undefined" ? Number(this.state.Advanceamount).toFixed(2) : "");


        console.log("save", row, this.state.Uststus);
        if (this.state.Uststus === true) {
            this.setState({ openBackdrop: true })

            await axios.post(genpostURL("CSARCNDEPOSIT/Save?="), parameter).then(res => {
                console.log("res data", res);
                //  await axios.post(genURLTEST("Save?="), parameter).then(res => {
                if (res.data.status === "success") {
                    this.setState({ opensnackbar: true })
                    this.setState({ color: "success" })
                    this.setState({ icon: ErrorIcon })
                    this.setState({ messagealert: "บันทึกสำเร็จ" })
                    setTimeout(() => {
                        this.setState({ openBackdrop: false })
                        this.ResetThisPage()
                    }, 30);
                } else {
                    this.setState({ opensnackbar: true })
                    this.setState({ color: "warning" })
                    this.setState({ icon: ErrorIcon })
                    this.setState({ messagealert: "บันทึกไม่สำเร็จ" + res.data })
                    this.setState({ openBackdrop: false })
                }
            }).catch(error => {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "เกิดข้อผิดพลาด" + error })
                this.setState({ openBackdrop: false })
            })
        }
    }
    ResetThisPage() {
        window.location.replace("/PSARCNDeposit");
    }
    setRow = (count) => {
        var data = [];
        for (var i = 0; i <= count - 1; i++) {
            data[i] = {
                li: i + 1,
                T_ฺฺC0: i,
                T_Code: "",
                T_Amount: "",
                T_SB: "0",
                T_tCode: "0"
            }
        }
        this.setState({ tableData: data });
    }
    AddDataRow = () => {

        var allrowTable = this.state.rowtb - 1;
        // console.log(test);
        var data = this.state.tableData;
        var j = 0;
        for (var i = 0; i <= allrowTable; i++) {
            if (data[i].T_Code !== "") {
                data[j] = {
                    li: j + 1,
                    T_ฺฺC0: j,
                    T_Code: data[i].T_Code,
                    T_List: data[i].T_List,
                    T_Explain: data[i].T_Explain,
                    T_Amount: data[i].T_Amount,
                    // T_Amount: this.int_format(data[i].T_Amount),
                    T_Department: data[i].T_Department,
                    T_Branch: data[i].T_Branch,
                    C7: data[i].C7,
                    C8: data[i].C8,
                    C9: data[i].C9,
                    C10: data[i].C10,
                    T_Department_Code: data[i].T_Department_Code,
                    T_Branch_Code: data[i].T_Branch_Code,
                    T_SB: data[i].T_SB,
                    BTN_T: data[i].BTN_T,
                    T_tCode: "0",
                    PROJECT: data[i].PROJECT,
                }
                j++;
            }
        }
        this.DeletRow(j, allrowTable);
        this.Cal_Price();

    }
    DeletRow = (str, end) => {
        // console.log(str);
        var data = this.state.tableData;
        for (var i = str; i <= end; i++) {
            data[i] = {
                li: i + 1,
                T_ฺฺC0: i,
                T_Code: "",
                T_Amount: "",
                T_SB: "0",
                T_tCode: ""
            }
        }
        this.setState({ tableData: data });
    }
    //-----------------------------------------------------------------
    Get_Arcode = async (event) => {
        if (event.key === 'Enter') {
            this.setState({ openBackdrop: true })
            var arcode = this.CustomerCode.current.value;
            var url = "CSAR/ARCode?arcode=" + arcode + "&user=" + localStorage.getItem("Username");
            console.log(genURL(url));
            await axios.get(genURL(url), { timeout: 3600 }).then(res => {
                if (res.data.length > 0) {
                    this.CustomerCode.current.value = res.data[0].CODE;
                    this.CustomerName.current.value = res.data[0].NAMETH;
                    this.setState({ openBackdrop: false })
                } else {
                    this.setState({ opensnackbar: true })
                    this.setState({ color: "warning" })
                    this.setState({ icon: ErrorIcon })
                    this.setState({ messagealert: "ไม่พบข้อมูล" })
                    this.CustomerCode.current.value = "";
                    this.CustomerName.current.value = "";
                    this.setState({ openBackdrop: false })
                }
            }).catch(error => {
                console.log(error);
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "ไม่สามารถโหลดข้อมูลได้" })
                this.setState({ openBackdrop: false })
            });
        }
    }
    Cal_Price = (e) => {
        var Sumamount1 = 0; // รวมจำนวนเงิน
        var Sumamount2 = 0; // มูลค่ายกเว้น
        var Debtamount = 0; // รวมทั้งสิ้น
        var Taxrate = 0;
        if (this.Taxrate.current.value) {
            Taxrate = parseFloat(this.Taxrate.current.value).toFixed(2);
        }
        this.Taxrate.current.value = parseFloat(Taxrate).toFixed(2);
        var TaxPersen = Number(this.Taxrate.current.value);
        //----------แยกเลือกประเภทการขาย-----------------
        var ty_code = this.state.PriceType_code;
        var CTaxamount = 0;
        for (var i = 0; i < this.state.tableData.length; i++) {
            if (this.state.tableData[i].T_Amount) {
                if (this.state.tableData[i].BTN_T === "1") {
                    if (ty_code === "0") {
                        Sumamount1 += parseFloat(this.state.tableData[i].T_Amount)
                        CTaxamount = 100
                        Debtamount = Sumamount1 + (TaxPersen * Sumamount1 / CTaxamount)
                    } else if (ty_code === "1") {
                        Sumamount1 += parseFloat(this.state.tableData[i].T_Amount)
                        CTaxamount = 100 + TaxPersen
                        Debtamount = Sumamount1
                    } else if (ty_code === "2") {
                        CTaxamount = 0
                        Sumamount1 += parseFloat(this.state.tableData[i].T_Amount)
                        Debtamount += parseFloat(this.state.tableData[i].T_Amount)
                    }
                } else {
                    console.log(ty_code);
                    if (ty_code === "0") {
                        CTaxamount = 100
                        Sumamount2 += parseFloat(this.state.tableData[i].T_Amount)
                        Debtamount += parseFloat(this.state.tableData[i].T_Amount)
                    } else if (ty_code === "1") {
                        CTaxamount = 100 + TaxPersen
                        Sumamount2 += parseFloat(this.state.tableData[i].T_Amount)
                        Debtamount += parseFloat(this.state.tableData[i].T_Amount)
                    } else if (ty_code === "2") {
                        CTaxamount = 0
                        Sumamount2 += parseFloat(this.state.tableData[i].T_Amount)
                        Debtamount += parseFloat(this.state.tableData[i].T_Amount)
                    }
                }
            }
        }
        //--------------------------------
        if (ty_code === "2") {
            this.Taxamount.current.value = "0.00"
        }
        else if (Sumamount1 !== 0.00) {
            this.Taxamount.current.value = parseFloat(TaxPersen * Sumamount1 / CTaxamount).toFixed(2)
        } else {
            this.Taxamount.current.value = "0.00"
        }
        this.Sumamount1.current.value = parseFloat(Sumamount1).toFixed(2)
        this.Totalamount.current.value = parseFloat(Sumamount1).toFixed(2)
        this.Sumamount2.current.value = parseFloat(Sumamount2).toFixed(2)
        this.Debtamount.current.value = parseFloat(Debtamount).toFixed(2);
        this.setState({ AmountPayable: this.Debtamount.current.value });
    }
    Cal_Price1 = (e) => {
        if (e.key === "Enter" && e.target.value !== "") {
            this.Cal_Price();
        }
    }
    addData = data => {
        switch (data.target.name) {
            case "data1": this.setState({ data1: data.target.value }); break;
            default:
                break;
        }
    }
    Get_UserCode = (data) => {
        this.setState({ UserCode_code: localStorage.getItem("Username") });
        this.setState({ UserCode_txt: localStorage.getItem('UsernameTH') });
        this.setState({ UserCode: localStorage.getItem('UsernameTH') });
        this.Csuser.current.value = localStorage.getItem("UsernameTH");
        /*var url = "https://psmdapi.pspl.co.th/CSHome/Profile?api_key="+DataConfig.API_KEY[localStorage.getItem("company")]+"&jwt="+localStorage.getItem("Token")+"&user="+data;
        axios.get(url).then(
            res =>{
                for(var i =0 ; i<res.data.length;i++){
                    this.setState({UserCode:res.data[i].code});
                    this.setState({UserCode_code:res.data[i].code}); 
                    this.setState({UserCode_txt:res.data[i].mynameth}); 
                    this.setState({UserCode:res.data[i].mynameth}); 
                }                    
            }
        );*/
    }
    SelectSetData = async (type, data, rowIndex) => {
        switch (type) {
            case "PriceType":
                this.setState({ PriceType_code: await String(data) })
                this.Cal_Price();
                break;
            case "Calendar1":
                this.setState({ Docdate: data })
                break;
            case "PROJECT":
                //textproject
                if (rowIndex === "") {
                    //console.log("PROJECTzzzzzzzzzzzzzzzzzz", data);
                    this.setState({ PROJECT: data })
                    //settableproject
                    for (let i = 0; i < this.state.tableData.length; i++) {
                        if (this.state.tableData[i].T_Code) {
                            this.state.tableData[i].PROJECT = data
                        }
                    }
                }
                // tableproject
                if (rowIndex !== "") {
                    this.state.tableData[Number(rowIndex)].PROJECT = data
                }
                break;
            default:
                break;
        }
    }
    SetPopup = (data) => {
        //  console.log("data SetPopup", data);
        this.setState({ PopUpTYpe: data });
        // this.setState({ showPopupOT: !this.state.showPopupOT });
        this.setState({ typeFullScreenDialogs: "Search_Table" })
        //open
        this.setState({ openFullScreenDialogs: true })
        //title
        this.setState({ titleFullScreenDialogs: "ค้นหารหัสรายได้อื่นๆ-Income" })
    }
    SetPopup1 = (e) => {
        console.log("data SetPopup", e);
        this.setState({ PopUpTYpe: e });
        // this.setState({ showPopupDB: !this.state.showPopupDB });
        this.setState({ typeFullScreenDialogs: e + "tb" })
        //open
        this.setState({ openFullScreenDialogs: true })
        if (e === "Department") {
            this.setState({ titleFullScreenDialogs: "เลือกรายการ-csdepartment" })
        }
        if (e === "Branch") {
            this.setState({ titleFullScreenDialogs: "เลือกรายการ-cssite" })
        }
    };
    Switch_PopupArcode = (e) => {
        // this.setState({ SwitchPopupArcode: !this.state.SwitchPopupArcode });
        //ชื่อ
        this.setState({ typeFullScreenDialogs: e })
        //open
        this.setState({ openFullScreenDialogs: true })
        //title
        this.setState({ titleFullScreenDialogs: "ค้นหาลูกค้า-AR" })
    }
    Switch_OtherPopup = (e) => {
        // this.setState({ OtPopupType: type })
        // this.setState({ SwitchOtherPopup: !this.state.SwitchOtherPopup });
        //ชื่อ
        this.setState({ OtPopupType: e })
        //ชื่อ
        this.setState({ typeFullScreenDialogs: e })
        //open
        this.setState({ openFullScreenDialogs: true })
        if (e === "Groupdata") {
            this.setState({ titleFullScreenDialogs: "เลือกรายการ-csdocgroup" })
        }
        if (e === "Department") {
            this.setState({ titleFullScreenDialogs: "เลือกรายการ-csdepartment" })
        }
        if (e === "Branch") {
            this.setState({ titleFullScreenDialogs: "เลือกรายการ-cssite" })
        }
    }

    Get_PopUparcode = (data1, data2) => {
        this.CloseDialog(false)
        this.CustomerCode.current.value = data1;
        this.CustomerName.current.value = data2;
    }

    Get_PopUpOther = async (val) => {
        this.CloseDialog(false)
        var data = val.split("|");
        for (var i = 0; i < data.length; i++) {
            data[i] = data[i].trim();
        }
        switch (this.state.typeFullScreenDialogs) {
            case "Groupdata":

                this.onAddValue("Groupdata", data[0], "")
                // this.Groupdata_code.current.value = data[0]
                // this.Groupdata.current.value = data[1]
                // this.setState({ Groupdata_txt: data[1] });
                // this.setState({ Groupcode: data[0] })
                // this.setState({ Groupname: data[1] })
                // await Chackdocno(data[0], "CSARCNDEPOSIT").then(async (result1) => {
                //     console.log(result1);
                //     if (result1 !== undefined) {
                //         this.DeliNumber.current.value = await result1
                //         this.setState({ Docno: result1 })
                //     } else {
                //         this.DeliNumber.current.value = ""
                //     }
                // }).finally(_ => {
                //     CheckTaxrate(data[0], "CSARCNDEPOSIT").then((result) => {
                //         console.log("sssss", result);
                //         this.Taxrate.current.value = result
                //     })
                // }).catch((err) => {
                //     this.DeliNumber.current.value = ""
                //     console.log(err);
                // });
                break;
            case "Department":
                this.Department_code.current.value = await data[0];
                this.Department.current.value = await data[1];
                this.setState({ Department_txt: data[1] });
                break;
            case "Branch":
                this.Branch_code.current.value = await data[0];
                this.Branch.current.value = await data[1];
                this.setState({ Branch_txt: data[1] });
                break;
            default:
                break;
        }
    };
    Get_PopUpOther2 = (data) => {
        //console.log("xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx");
        this.CloseDialog(false)
        var split_data = data.split("|");
        switch (this.state.typeFullScreenDialogs) {
            case "Depositno":
                this.Depositno.current.value = split_data[0];
                break;
            case "Sitecode":
                this.setState({ SiteCode_txt: split_data[1] });
                this.setState({ SiteCode_code: split_data[0] });
                this.Branch.current.value = split_data[1];
                break;
            // เพิ่มข้อมูลในตาราง
            case "T_Expcode":
                let col = this.state.tableData;
                let j = this.state.rowChk_wtb
                for (var i = 0; i < col.length; i++) {
                    if (col[i].T_Code !== split_data[0] && (col[i].T_Code === undefined || col[i].T_Code === "")) {
                        col[j].T_Code = split_data[0];
                        col[j].T_List = split_data[1];
                        // Auto แผนก
                        if (this.Department.current.value !== "") {
                            col[j].T_Department = this.Department.current.value
                            col[j].T_Department_Code = this.Department_code.current.value
                        } else {
                            col[j].T_Department = "";
                            col[j].T_Department_Code = "";
                        }
                        // Auto สาขา
                        if (this.Branch.current.value !== "") {
                            col[j].T_Branch = this.Branch.current.value
                            col[j].T_Branch_Code = this.Branch_code.current.value
                        } else {
                            col[j].T_Branch = "";
                            col[j].T_Branch_Code = "";
                        }
                        if (this.state.PROJECT !== "") {
                            col[j].PROJECT = this.state.PROJECT
                        }
                        col[j].BTN_T = split_data[4]; // 1 ไม่ติก
                        col[j].T_Amount = 0.00.toFixed(2);
                        break;
                    }
                    // else if (col[i].T_Code === split_data[0]) {
                    //     break
                    // }
                    this.setState({ tableData: col });
                }
                break;
            default:
                break;
        }
        this.setState({ showPopupOT: !this.state.showPopupOT });
    }

    Get_PopUpDB = (data) => {
        this.CloseDialog(false)
        var split_data = data.split("|");
        switch (this.state.PopUpTYpe) {
            case "Department":
                let arrData2 = this.state.tableData;
                arrData2[this.state.rowChk_wtb].T_Department_Code = split_data[0]
                arrData2[this.state.rowChk_wtb].T_Department = split_data[1]
                this.setState({ tableData: arrData2 });
                break;
            case "Branch":
                let arrData3 = this.state.tableData;
                arrData3[this.state.rowChk_wtb].T_Branch_Code = split_data[0]
                arrData3[this.state.rowChk_wtb].T_Branch = split_data[1];
                this.setState({ tableData: arrData3 });
                break;
            default: break;
        }
    };
    SetPopup3 = (e) => {
        if (this.state.PriceType_code && this.CustomerCode.current.value) {
            this.setState({ PopUpTYpe3: e });
            // this.setState({ showPopupOT3: !this.state.showPopupOT3 });
            //ชื่อ
            this.setState({ typeFullScreenDialogs: e })
            //open
            this.setState({ openFullScreenDialog: true })
            //title
            this.setState({ titleFullScreenDialogs: "ค้นหาใบรับเงินมัดจำ-SelARDepositUse" })
        } else {
            if (this.CustomerCode.current.value === "") {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณาใส่รหัสลูกหนี้" })
            } else {
                if (this.state.PriceType_code === "") {
                    this.setState({ opensnackbar: true })
                    this.setState({ color: "warning" })
                    this.setState({ icon: ErrorIcon })
                    this.setState({ messagealert: "กรุณาเลือกประเภทราคา" })
                }
            }
        }
    }
    Get_PopUpOther3 = async (data) => {
        this.CloseDialog(false)
        this.Depositno.current.value = data;
        switch (this.state.typeFullScreenDialogs) {
            case "Depositno":
                var url = "CSARDEPOSIT/Getdatasub?DOCNO=" + data;
                var j = 0;
                await axios.get(genURL(url), { timeout: 3600 }).then(async res => {
                    if (res.data) {
                        let arrData = this.state.tableData;
                        for (let i = 0; i < res.data.length; i++) {
                            // for (j = 0; j < arrData.length && arrData[j].T_Code; j++) {
                            //     if (arrData[j].T_Code === res.data[i].EXPCODE) {
                            //         return
                            //     }
                            // }
                            arrData[j].T_Code = res.data[i].EXPCODE;
                            arrData[j].T_List = res.data[i].EXPNAME;
                            arrData[j].T_Explain = res.data[i].REMARK;
                            arrData[j].T_Amount = this.int_format(res.data[i].AMOUNT);
                            arrData[j].T_Department = await department(res.data[i].DEPARTMENT);
                            arrData[j].T_Department_Code = res.data[i].DEPARTMENT;
                            arrData[j].T_Branch = await branch(res.data[i].SITECODE);
                            arrData[j].T_Branch_Code = res.data[i].SITECODE;
                            arrData[j].T_tCode = "0"
                            arrData[j].BTN_T = String(res.data[i].CALCTAX);
                            this.onAddValue("Department", res.data[i].DEPARTMENT);
                            this.onAddValue("Branch", res.data[i].SITECODE);
                            j++
                        }
                        await this.setState({ tableData: arrData });
                    }
                }).catch(error => {
                    console.log(error);
                });
                await this.Cal_Price();
                this.setdelete_no();
                break;
        }
        this.setState({ showPopupOT3: !this.state.showPopupOT3 });
    }
    PopUpOtherClose3 = () => {
        this.setState({ showPopupOT3: !this.state.showPopupOT3 });
    }
    //--------------------------
    PopUpOtherClose = () => {
        this.setState({ showPopupOT: !this.state.showPopupOT });
    }
    PopUpOtherClose1 = () => {
        this.setState({ showPopupDB: !this.state.showPopupDB })
    };
    _cellButton(cell, row, enumObject, rowIndex) {
        var btn = this.state.tableData[rowIndex].BTN_Code;
        var btnShow = "";
        switch (btn) {
            case 1: btnShow =
                <div style={{ cursor: "pointer", fontSize: "14px" }}
                    onClick={() => this.openDialog("T_Expcode")}
                >
                    <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
                </div>
                break;
            default: btnShow = <i className=""></i>; break;
        }
        return (<div >{btnShow}</div>);
    }
    _cellButton2(cell, row, enumObject, rowIndex) {
        var btn = this.state.tableData[rowIndex].BTN_Department;
        var btnShow = "";
        switch (btn) {
            case 1: btnShow =
                <div style={{ cursor: "pointer", fontSize: "14px" }}
                    onClick={this.SetPopup1.bind(null, "Department")}
                >
                    <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
                </div>
                break;
            default: btnShow = <i className=""></i>; break;
        }
        return (<div>{btnShow}</div>);
    }
    _cellButton3(cell, row, enumObject, rowIndex) {
        var btn = this.state.tableData[rowIndex].BTN_Branch;
        var btnShow = "";
        switch (btn) {
            case 1: btnShow =
                <div style={{ cursor: "pointer", fontSize: "14px" }}
                    onClick={this.SetPopup1.bind(null, "Branch")}
                >
                    <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
                </div>
                break;
            default: btnShow = <i className=""></i>; break;
        }
        return (<div>{btnShow}</div>);
    }
    onRowClick = (row, col, id) => {
        console.log("onRowClick");
        this.setState({ cellValue: row.T_Code })
        this.setState({ id: id });
        var arrData = this.state.tableData;
        var j = row.T_ฺฺC0 - 1;

        // จำนวนเต็มเวลาคลิก
        let T_Amount = row.T_Amount
        if (col === 5 && T_Amount !== "" && T_Amount !== undefined) {
            row.T_Amount = parseFloat(T_Amount).toFixed(0)
        }

        // ไม่ให้คีย์ข้ามแถว
        this.setState({ col1: false });
        this.setState({ col: false });

        for (var i = 0; i < arrData.length; i++) {
            arrData[i].BTN_Code = 0;
            arrData[i].BTN_Department = 0;
            arrData[i].BTN_Branch = 0;
        }

        // หาจากล่างขึ้นบน
        for (var i = this.state.tableData.length - 1; i >= 0; i--) {
            //หา แถวที่ว่างบนสุดใน products Table
            if (!this.state.tableData[i].T_Code) {
                j = i;
            }
        }

        // BTN ค้นหาได้เฉพาะในแถว
        if ((col === 1 && j === id) || (col === 1 && arrData[id].T_Code !== "")) {
            this.setState({ col1: true });
            arrData[id].BTN_Code = 1;
            this.setState({ tableData: arrData });
        } else if (col === 6 && typeof row.T_Code !== "undefined" && row.T_Code !== "") {
            arrData[id].BTN_Department = 1;
            arrData[id].T_Department = arrData[id].T_Department_Code;
        } else if (col === 9 && typeof row.T_Code !== "undefined" && row.T_Code !== "") {
            arrData[id].BTN_Branch = 1;
            arrData[id].T_Branch = arrData[id].T_Branch_Code;
        }

        // ให้เพิ่มข้อมูลในแถวที่มีรหัสสินค้าได้
        if (typeof row.T_Code !== "undefined" && row.T_Code !== "" && row.T_Code !== undefined) {
            this.setState({ col: true });
        }

        this.setState({ tableData: arrData });
        this.setState({ rowChk_wtb: row.T_ฺฺC0 });
    }
    afterSaveCell = async (row, cellName, cellValue) => {

        let col = this.state.tableData;
        let i = row.T_ฺฺC0;
        let j = row.T_ฺฺC0 - 1;

        // ทศนิยม 2 ตำแหน่ง ปริมาณ  ลด
        let T_Amount = row.T_Amount;
        if (cellName === "T_Amount" && T_Amount !== "") {
            row.T_Amount = parseFloat(T_Amount).toFixed(2)
        }
        var cellValue1 = this.state.cellValue
        console.log("urlcheckkkkkkkkkkkkkkkkkkkk");
        if (cellName === 'T_Code' && cellValue !== "" && cellValue1 !== cellValue) {
            var url = "CSINCOME/GETCODE?Code=" + cellValue + "&user=" + localStorage.getItem("Username");
            console.log("afterSaveCell", genURL(url));
            await axios.get(genURL(url), { timeout: 3600 }).then(res => {
                if (res.data.length === 1) {
                    col[i].T_Code = res.data[0].CODE;
                    col[i].T_List = res.data[0].MYNAMETH;
                    col[i].T_Amount = "0.00";
                    col[i].BTN_T = String(res.data[0].CALCTAX);
                    // Auto แผนก
                    if (this.Department.current.value !== "") {
                        col[i].T_Department = this.Department.current.value
                        col[i].T_Department_Code = this.Department_code.current.value
                    } else {
                        col[i].T_Department = "";
                        col[i].T_Department_Code = "";
                    }
                    // Auto สาขา
                    if (this.Branch.current.value !== "") {
                        col[i].T_Branch = this.Branch.current.value
                        col[i].T_Branch_Code = this.Branch_code.current.value
                    } else {
                        col[i].T_Branch = "";
                        col[i].T_Branch_Code = "";
                    }
                    if (this.state.PROJECT !== "") {
                        col[i].PROJECT = this.state.PROJECT
                    }
                } else {
                    col[i].T_Code = "";
                    col[i].T_List = "";
                    col[i].T_Amount = "";
                    this.AddDataRow();
                }
                this.setState({ tableData: col });
            }).catch(error => {
                console.log(error);
            });

        }

        // แผนกไม่เท่ากับค่าว่าง 
        if (cellName === "T_Department" && cellValue !== "") {
            var url1 = "CSDEPARTMENT/ByCode?code=" + cellValue + "&user=" + localStorage.getItem("Username");
            console.log(genURL(url1));
            await axios.get(genURL(url1), { timeout: 3600 }).then(res => {
                if (res.data.length === 1) {
                    col[i].T_Department_Code = res.data[0].CODE;
                    col[i].T_Department = res.data[0].MYNAMETH;
                    col[i].BTN_Department = 0;
                } else { // ใส่ข้อมูลไม่ถูก
                    col[i].T_Department_Code = "";
                    col[i].T_Department = "";
                    col[i].BTN_Department = 0;
                }
                this.setState({ tableData: col });
            }).catch(error => {
                console.log(error);
            });
        }

        // สาขาไม่เท่ากับค่าว่าง 
        if (cellName === "T_Branch" && cellValue !== "") {
            var url2 = "CSSITE/Getsite?Code=" + cellValue + "&user=" + localStorage.getItem("Username");
            console.log(genURL(url2));
            await axios.get(genURL(url2), { timeout: 3600 }).then(res => {
                if (res.data.length === 1) {
                    col[i].T_Branch_Code = res.data[0].CODE;
                    col[i].T_Branch = res.data[0].MYNAMETH;
                    col[i].BTN_Branch = 0;
                } else { // ใส่ข้อมูลไม่ถูก
                    col[i].T_Branch_Code = "";
                    col[i].T_Branch = "";
                    col[i].BTN_Branch = 0;
                }
                this.setState({ tableData: col });
            }).catch(error => {
                console.log(error);
            });
        }
        if (cellValue === "" && cellName === "T_Code" && row.T_Code === "") {
            setTimeout(() => {
                col[i].BTN_Code = 2;
                col[i].BTN_Department = 2;
                col[i].BTN_Branch = 2;
                this.setState({ tableData: col });
            }, 200);
        }
        this.AddDataRow();
        col[i].BTN_Code = 1
        col[i].BTN_Department = 1
        col[i].BTN_Branch = 1
        col[i].T_tCode = "0";
        this.setState({ tableData: col });
    }
    SetRowNull = (RowId) => {
        var data = this.state.tableData;
        for (var i = 0; i <= this.state.rowtb - 1; i++) {
            if (i === RowId) {
                data[RowId] = {
                    li: i + 1,
                    T_ฺฺC0: i,
                    T_Code: "",
                    T_List: "",
                    T_Explain: "",
                    T_Amount: "",
                    T_Department: "",
                    T_Branch: "",
                    C7: "",
                    C8: "",
                    C9: "",
                    C10: "",
                    T_Department_Code: "",
                    T_Branch_Code: "",
                    T_tCode: "0"
                }
            }
        }
        this.setState({ tableData: data });
    }
    int_format = (int) => {
        var re = 0;
        if (int) {
            re = parseFloat(int).toFixed(2);
        } else {
            re = parseFloat(re).toFixed(2);
        }
        return re;
    }
    //-------------------ลบแถว
    setdelete_load = () => {
        this.setState({ CSdelete: "" });
        this.setState({ CSdeletes: false });
        this.setState({ CSdelete_yes: false });
    }

    setdelete_no = () => {
        this.setState({ CSdelete: "far fa-square" });
        this.setState({ CSdeletes: false });
        this.setState({ CSdelete_yes: false });
    }
    setdelete_yes = () => {
        this.setState({ CSdelete: "fas fa-trash-alt" });
        this.setState({ CSdeletes: true });
        this.setState({ CSdelete_yes: true });
    }

    selectRowData = (cell, row, enumObject, rowIndex) => {
        var btn = this.state.tableData[rowIndex].T_SB;
        var btnShow;
        var lid = "lid" + rowIndex;
        switch (btn) {
            case "0":
                if (this.state.tableData[rowIndex].T_Code !== "") {
                    btnShow = <span   >
                        <i className="" style={{ fontSize: '20px' }} onClick={this.Update_Status.bind(null, rowIndex, "1")}> {row.li}</i>
                    </span>;
                } else {
                    btnShow = <span >
                        <i className="" style={{ fontSize: '20px' }} > {row.li}</i><i style={{ paddingLeft: '5px' }} id={lid}></i>
                    </span>;
                }
                break;
            case "1": btnShow = <span>
                <i style={{ color: '#ff0000', marginTop: '3px' }} className="far fa-minus-square" onClick={this.Update_Status.bind(null, rowIndex, "0")}>  </i>
            </span>;
                break;
            default: btnShow = <span><i className="">  </i></span>;
        }
        return (<div >{btnShow}</div>)
    }

    deleterowall = (Row, Status) => {
        if (this.state.CSdeletes === false) {
            var dataArray = this.state.tableData;
            for (var i = 0; i < this.state.tableData.length && this.state.tableData[i].T_Code; i++) {
                dataArray[i].T_SB = "1";
                this.setState({ tableData: dataArray });
            }
            if (i > 0) {
                this.setdelete_yes();
                this.setState({ CSdeletes: !this.state.CSdeletes });
            }
        }
        if (this.state.CSdelete_yes === true) {
            var dataArray = this.state.tableData;
            for (var i = 0; i < this.state.tableData.length && this.state.tableData[i].T_Code; i++) {
                if (this.state.tableData[i].T_SB === 1) {
                    dataArray[i].T_Code = "";
                }
            }
            this.setState({ tableData: dataArray });
            this.setRow(this.state.rowtb);
            //this.AddDataRow();
            this.setdelete_load();
        }
    }

    Update_Status = (Row, Status) => {
        if (Status === 0) {
            var dataArray = this.state.tableData;
            dataArray[Row].T_Code = "";
            this.setState({ tableData: dataArray });
            this.AddDataRow();
            //setTimeout(() => { 
            //this.AddDataRow();
            //}, 30);

            for (var i = 0; i < this.state.tableData.length && this.state.tableData[i].T_Code; i++) { }
            if (i <= 0) {
                this.setdelete_load();
            }
        } else {
            var dataArray = this.state.tableData;
            dataArray[Row].T_SB = Status;
            this.setState({ tableData: dataArray });

            var chk_all = 0;
            var chk_all_y = 0;
            for (var i = 0; i < this.state.tableData.length && this.state.tableData[i].T_Code; i++) {
                chk_all_y = chk_all_y + 1;
                if (this.state.tableData[i].T_SB === 1) {
                    chk_all = chk_all + 1;
                }
            }
            if (chk_all === chk_all_y && chk_all_y > 0) {
                this.setdelete_yes();
            }
        }
    }
    t_Status = (Row, Status) => {
        var dataArray = this.state.tableData;
        dataArray[Row].BTN_T = Status;
        this.setState({ tableData: dataArray });
        setTimeout(() => {
            this.Cal_Price()
        }, 100);
    }

    //--------------------------
    customStyle = () => {
        return {
            backgroundColor: '#f2f2f2'
        };
    }
    convertimeps = (date) => {
        if (date) {
            var myDate = new Date(date);
            var date = myDate.getDate(); if (myDate.getDate() < 10) { date = "0" + myDate.getDate(); }
            var month = (myDate.getMonth() + 1); if ((myDate.getMonth() + 1) < 10) { month = "0" + (myDate.getMonth() + 1); }
            var year = myDate.getFullYear() + 543;
            return date + "/" + month + "/" + year;
        } else {
            return "";
        }
    }
    onAddValue = async (type, value, Fix) => {
        console.log("sssss", value);
        if (value) {
            switch (type) {
                case "Groupdata":
                    await CheckTaxgroup(value, "CSARCNDEPOSIT").then((result) => {
                        console.log("CheckTaxgroup", result);
                        this.setState({
                            taxgroup: result
                        })
                    })

                    await console.log("taxgroup", this.state.taxgroup)
                    Checkdocgroup(value, "CSARCNDEPOSIT", Fix).then(async (result) => {
                        if (result !== "") {
                            this.Groupdata_code.current.value = value
                            this.Groupdata.current.value = result
                            this.setState({ Groupdata_txt: result });
                            this.setState({ Groupcode: value })
                            this.setState({ Groupname: result })

                            if (Fix !== "Y") {
                                await Chackdocno(value, "CSARCNDEPOSIT").then((result1) => {
                                    if (result1 !== "") {
                                        this.DeliNumber.current.value = result1
                                        this.setState({ Docno: result1 })
                                    } else {
                                        this.DeliNumber.current.value = ""
                                    }
                                }).catch((err) => {
                                    this.DeliNumber.current.value = ""
                                    console.log(err);
                                }).finally(_ => {
                                    CheckTaxrate(value, "CSARCNDEPOSIT").then((result) => {
                                        console.log("sssss", result);
                                        this.Taxrate.current.value = result
                                    })
                                });


                            }
                        } else {
                            this.setState({ opensnackbar: true })
                            this.setState({ color: "warning" })
                            this.setState({ icon: ErrorIcon })
                            this.setState({ messagealert: "ไม่พบข้อมูล" })
                            this.Groupdata_code.current.value = ""
                            this.Groupdata.current.value = ""
                            this.setState({ Groupdata_txt: "" });
                            this.DeliNumber.current.value = ""
                        }
                    }).finally(_ => {
                        try {
                            if (this.state.recheckeddata.length <= 0) {
                                CheckTaxrate(value, "CSARCNDEPOSIT").then((result) => {
                                    console.log("sssss", result);
                                    this.Taxrate.current.value = result
                                })
                            }
                        } catch (err) {

                        }
                    }).catch((err) => {
                        try {
                            if (this.state.recheckeddata.length <= 0) {
                                this.Groupdata_code.current.value = ""
                                this.Groupdata.current.value = ""
                                this.setState({ Groupdata_txt: "" });
                                this.DeliNumber.current.value = ""
                                console.log("catch", err);
                            }
                        } catch (error) {

                        }

                    });
                    break;
                case "CustomerCode":
                    await ChackAr(value).then((result) => {
                        console.log(result);
                        if (result !== "") {
                            let data = result.split("|")
                            this.CustomerCode.current.value = value
                            this.CustomerName.current.value = data[0]
                        } else {
                            this.setState({ opensnackbar: true })
                            this.setState({ color: "warning" })
                            this.setState({ icon: ErrorIcon })
                            this.setState({ messagealert: "ไม่พบข้อมูล" })
                            this.CustomerCode.current.value = ""
                            this.CustomerName.current.value = ""
                        }
                    }).catch((err) => {
                        this.CustomerCode.current.value = ""
                        this.CustomerName.current.value = ""
                        console.log(err);
                    });
                    break;
                case "Csuser":
                    console.log("sssssCSUSER");
                    await CheckUser(value).then(async (result) => {
                        if (result !== "") {
                            this.Csuser_code.current.value = await value
                            this.Csuser.current.value = await result
                        } else {
                            this.setState({ opensnackbar: true })
                            this.setState({ color: "warning" })
                            this.setState({ icon: ErrorIcon })
                            this.setState({ messagealert: "ไม่พบข้อมูลพนักงาน" })
                            this.Csuser_code.current.value = ""
                            this.Csuser.current.value = ""
                        }
                    }).catch((err) => {
                        this.Csuser_code.current.value = ""
                        this.Csuser.current.value = ""
                        console.log(err);
                    });
                    break;
                case "Department":
                    await CheckDepartmentname(value).then((result) => {
                        if (result !== "") {
                            this.Department_code.current.value = value
                            this.Department.current.value = result
                            this.setState({ Department_txt: result });
                        } else {
                            this.setState({ opensnackbar: true })
                            this.setState({ color: "warning" })
                            this.setState({ icon: ErrorIcon })
                            this.setState({ messagealert: "ไม่พบข้อมูล" })
                            this.Department_code.current.value = ""
                            this.Department.current.value = ""
                            this.setState({ Department_txt: "" });
                        }
                    }).catch((err) => {
                        this.Department_code.current.value = ""
                        this.Department.current.value = ""
                        this.setState({ Department_txt: "" });
                        console.log(err);
                    });
                    break;
                case "Branch":
                    await CheckBrabchname(value).then((result) => {
                        if (result !== "") {
                            this.Branch_code.current.value = value
                            this.Branch.current.value = result
                            this.setState({ Branch_txt: result });
                        } else {
                            this.setState({ opensnackbar: true })
                            this.setState({ color: "warning" })
                            this.setState({ icon: ErrorIcon })
                            this.setState({ messagealert: "ไม่พบข้อมูล" })
                            this.Branch_code.current.value = ""
                            this.Branch.current.value = ""
                            this.setState({ Branch_txt: "" });
                        }
                    }).catch((err) => {
                        this.Branch_code.current.value = ""
                        this.Branch.current.value = ""
                        this.setState({ Branch_txt: "" });
                        console.log(err);
                    });
                    break;
                default: break;
            }
        }
    }
    pricetype = async (Texttype) => {
        let strTexttype = String(Texttype)
        this.setState({ defaultselect: [strTexttype] })
        this.setState({ PriceType_code: await strTexttype });
        this.Cal_Price();
    }

    reCheckData = async (type, val, fix) => {
        switch (type) {
            case "Groupdata":
                CheckCodeDocGroup(val, "CSARCNDEPOSIT").then((result) => {
                    console.log("result Groupdata", result);
                    this.Groupdata_code.current.value = val
                    this.Groupdata.current.value = result
                    this.setState({ Groupdata_txt: result });
                    this.setState({ Groupcode: val })
                    this.setState({ Groupname: result })
                }).finally(_ => {
                    CheckTaxrate(val, "CSARCNDEPOSIT").then(async (result) => {
                        //  this.TaxPersen.current.value = await result
                        this.Taxrate.current.value = result
                    })
                })
                break;
        }
    }
    _reCHK = async (RowData) => {

        this.CloseDialog(false)
        this.setRow(this.state.rowtb);
        this.setState({ _saveStatus: true, openBackdrop: true });
        this.setState({ Save_status: "disabled" });
        var url = "CSARCNDEPOSIT/GetDatabycodemain?code=" + RowData[0].docNo;
        console.log("_reCHK", genURL(url));
        await axios.get(genURL(url)).then(async res => {

            if (res.data !== "") {
                console.log("_reCHK  res.data ", res.data);
                this.setState({ resrecheckeddata: res.data })
                this.CustomerCode.current.value = res.data[0].ARCODE
                this.CustomerName.current.value = res.data[0].ARNAME
                this.DeliNumber.current.value = res.data[0].DOCNO
                this.Remark.current.value = res.data[0].REMARK
                this.pricetype(res.data[0].TAXTYPE);
                this.setState({ Docdate: this.convertimeps(res.data[0].DOCDATE) })
                this.Depositno.current.value = res.data[0].DEPOSITNO
                //  this.onAddValue("Groupdata", res.data[0].DOCGROUP, "Y")
                await this.reCheckData("Groupdata", res.data[0].DOCGROUP, true)
                this.onAddValue("Csuser", res.data[0].USERCODE);
                this.onAddValue("Department", res.data[0].DEPARTMENT);
                this.onAddValue("Branch", res.data[0].SITECODE);
                this.Taxamount.current.value = res.data[0].TAXAMOUNT;
                this.Taxrate.current.value = res.data[0].TAXRATE;
                this.Sumamount1.current.value = res.data[0].SUMAMOUNT1;
                this.Sumamount2.current.value = res.data[0].SUMAMOUNT2;
                this.Debtamount.current.value = res.data[0].DEBTAMOUNT;
                this.Totalamount.current.value = res.data[0].TOTALAMOUNT;
                this.Round_PAY.current.value = res.data[0].Round_PAY
            }
        }).catch(error => {
            console.log(error);
        });
        var url2 = "CSARCNDEPOSIT/GetDatabycodesub?code=" + RowData[0].docNo;
        console.log(genURL(url2));
        await axios.get(genURL(url2), { timeout: 3600 }).then(async res2 => {
            var datatable = this.state.tableData;
            for (var i = 0; i < res2.data.length; i++) {
                datatable[i].T_Code = res2.data[i].EXPCODE;
                datatable[i].T_List = res2.data[i].EXPNAME;
                datatable[i].T_Explain = res2.data[i].REMARK;
                datatable[i].T_Amount = res2.data[i].AMOUNT;
                datatable[i].T_Department_Code = res2.data[i].DEPARTMENT;
                datatable[i].T_Department = await department(res2.data[i].DEPARTMENT);
                datatable[i].T_Branch_Code = res2.data[i].SITECODE;
                datatable[i].T_Branch = await branch(res2.data[i].SITECODE);
                if (res2.data[i].CALCTAX === 1) {
                    datatable[i].BTN_T = "1";
                } else {
                    datatable[i].BTN_T = "0";
                }
            }

            await this.setState({ tableData: datatable });
            setTimeout(() => {
                this.Cal_Price();
            }, 1000);
        }).catch(error => {
            console.log(error);
        });

        this.setState({ openBackdrop: false });
    }
    ResetDocSent = () => {
        window.location.reload();
    }

    _print = () => {
        if (!this.DeliNumber.current.value) {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณากรอกเลขที่เอกสาร" })
        }
        else {
            this._callForm(this.DeliNumber.current.value);
        }
    }
    _callForm = (vel) => {
        let url1 = "https://csrpt.pspl.co.th/jasperserver/flow.html?_flowId=viewReportFlow&_flowId=viewReportFlow&ParentFolderUri=%2Freports%2FPSMT_report%2FPSMT_FROM&reportUnit=%2Freports%2FPSMT_report%2FPSMT_FROM%2FARCNDEPOSIT&standAlone=true&api_key=0WXZeIZXvvbBEoIotvJSC7H3vXnoPfRul9xNdF1u&j_username=rpt&j_password=042615116&output=pdf&docno=" + vel;
        this.setState({ urlsend: url1 })
        setTimeout(() => {
            this.switchshowform();
        }, 100);
    }

    switchshowform = (e) => {
        this.setState({ showform: !this.state.showform });
    }

    cellcheckT = (cell, row, enumObject, rowIndex) => {
        if (typeof row.T_Code !== "undefined" && row.T_Code !== "") {
            var BTN = this.state.tableData[rowIndex].BTN_T;
            var btnShowT;
            switch (BTN) {
                case "0":
                    btnShowT = (
                        <span>
                            <i className="far fa-square " onClick={this.t_Status.bind(null, rowIndex, "1")} style={{ paddingTop: "7px" }}></i>
                        </span>
                    );
                    break;
                case "1":
                    btnShowT = (
                        <span>
                            <i className="far fa-check-square" onClick={this.t_Status.bind(null, rowIndex, "0")} style={{ paddingTop: "7px" }} ></i>
                        </span>
                    );
                    break;
                default:
                    btnShowT = (
                        <span>
                            <i className=""> </i>
                        </span>
                    );
            }
            return <div>{btnShowT}</div>;
        }
    }
    CloseDialog = (e) => {
        this.setState({ openFullScreenDialogs: e })
    }
    ReturnData = (e) => {
        this.CloseDialog(e[0])
        console.log(e);
        if (e[1]) {
            this.setState({ multipletax: [...e[1]] })
        }
        if (e[2]) {
            this.setState({ Docdate1: e[2] })
        }
        if (e[3]) {
            this.setState({ Groupcode: e[3] })
        } else if (e[3] === "") {
            this.setState({ Groupcode: "" })
        }
        if (e[4]) {
            this.setState({ Groupname: e[4] })
        } else if (e[4] === "") {
            this.setState({ Groupname: "" })
        }
        if (e[5]) {
            this.setState({ Docno: e[5] })
        } else if (e[5] === "") {
            this.setState({ Docno: "" })
        }
        if (e[6]) {
            this.CustomerCode.current.value = e[6]
        }
        if (e[7]) {
            this.CustomerName.current.value = e[7]
        }
        if (e[8]) {
            this.setState({ Remark: e[8] })
        } else if (e[8] == "") {
            this.setState({ Remark: "" })
        }
    }
    openDialog = async (e) => {
        console.log("eeeeeeeeeeee", e);
        await this.setState({ typeFullScreenDialogs: e })
        if (e === "Payrecord") {
            await this.setState({ openFullScreenDialogs: true, titleFullScreenDialogs: "บันทึกจ่ายเงิน" })

        } else if (e === 'Search_ARCode') {
            await this.setState({ openFullScreenDialogs: true, titleFullScreenDialogs: "ค้นหาลูกหนี้" })

        }
        else if (e === 'Groupdata') {
            await this.setState({ openFullScreenDialogs: true, titleFullScreenDialogs: "กลุ่มข้อมูล" })

        } else if (e === 'Depositno') {
            await this.setState({ openFullScreenDialogs: true, titleFullScreenDialogs: "ใบรับเงินมัดจำ" })

        } else if (e === 'Department') {
            await this.setState({ openFullScreenDialogs: true, titleFullScreenDialogs: "แผนก" })

        } else if (e === 'Branch') {
            await this.setState({ openFullScreenDialogs: true, titleFullScreenDialogs: "สาขา" })

        } else if (e === 'T_Expcode') {
            await this.setState({ openFullScreenDialogs: true, titleFullScreenDialogs: "รายการ" })

        } else if (e === 'Inputmultipletax') {
            var Data = []
            Data = {
                from: "CSARDEPOSIT",
                userSite: this.state.siteCodeUser,
                defult: this.state.multipletax,
                Docdate: this.state.Docdate1,
                Groupdata_code: this.state.Groupcode,
                Groupdata: this.state.Groupname,
                DeliNumber: this.state.Docno,
                Code: this.CustomerCode.current.value,
                Name: this.CustomerName.current.value,
                Remark: this.state.Remark,
                TaxPersen: this.Taxrate.current.value,
                Total: this.Totalamount.current.value,
            }
            this.setState({ dataMultipletax: Data })

            if (this.state.Docdate === "") {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณากรอกวันที่ก่อน ...!" })
                return
            }

            if (this.CustomerCode.current.value === "") {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณากรอกข้อมูลเจ้าหนี้ก่อน ...!" })
                return
            }
            if (this.CustomerName.current.value === "") {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณากรอกข้อมูลเจ้าหนี้ก่อน ...!" })
                return
            }
            this.setState({ openFullScreenDialogs: true })
            this.setState({ titleFullScreenDialogs: "เลือกใบกำกับภาษีหลายใบ" })
            this.setState({ typeFullScreenDialogs: e })
        }
    }
    Chackdoc = () => {
        Chackdocno(this.Groupdata_code.current.value, "CSARCNDEPOSIT").then(async (result1) => {
            if (result1 !== undefined) {
                this.DeliNumber.current.value = await result1
            } else {
                this.DeliNumber.current.value = ""
            }
        }).catch((err) => {
            this.DeliNumber.current.value = ""
            console.log(err);
        });
    }
    onClick = (e) => {
        if (e.target.value !== "") {
            switch (e.target.name) {
                case "Groupdata":
                    this.Groupdata.current.value = this.Groupdata_code.current.value
                    break;
                case "Department":
                    this.Department.current.value = this.Department_code.current.value
                    break;
                case "Branch":
                    this.Branch.current.value = this.Branch_code.current.value
                    break;
                case "Round_PAY":
                    this.Round_PAY.current.value = Number(e.target.value); e.target.select()
                    break;
                default:
                    break;
            }
        }
    }
    onKeyDown = (e) => {
        if (e.key === "Enter") {
            if (e.target.name === "Groupdata") {
                this.onAddValue("Groupdata", e.target.value);
            }
            if (e.target.name === "CustomerCode") {
                this.onAddValue("CustomerCode", e.target.value);
            }
            console.log(e.target.name);
            if (e.target.name === "Department") {
                this.onAddValue("Department", e.target.value);
            }
            if (e.target.name === "Branch") {
                this.onAddValue("Branch", e.target.value);
            }
        }
    };
    onChange = async (e) => {
        switch (e.target.name) {
            case 'Groupdata':
                if (e.target.value === "") {
                    this.setState({ Groupdata_txt: "" })
                    this.Groupdata_code.current.value = "";
                    this.DeliNumber.current.value = "";
                }
                break;
            case 'CustomerCode':
                if (e.target.value === "") {
                    this.CustomerCode.current.value = "";
                    this.CustomerName.current.value = "";
                }
                break;
            case 'Department':
                if (e.target.value === "") {
                    this.setState({ Department_txt: "" })
                    this.state.Department_txt = ""
                }
                break;
            case 'Branch':
                if (e.target.value === "") {
                    this.setState({ Branch_txt: "" })
                    this.Branch_code.current.value = ""
                }
                break;
            default:
                break;
        }
    }
    onBlur = async (e) => {

        console.log("ssssssssssssssssssssssssssssssss", e.target.value);

        if (e.target.name === "Groupdata") {
            this.Groupdata.current.value = this.state.Groupdata_txt;
        }
        if (e.target.name === "Department") {
            this.Department.current.value = this.state.Department_txt;
        }
        if (e.target.name === "Branch") {
            this.Branch.current.value = this.state.Branch_txt;
        }
        if (e.target.name === "Round_PAY") {
            this.Round_PAY.current.value = Number(e.target.value).toFixed(2)
        }
    };
    onClickTopbar = (e) => {
        console.log(e);
        switch (e) {
            case "save":
                this._saveConnection()
                break;
            case "new":
                this.ResetDocSent()
                break;
            case "print":
                this._print(null)
                break;
            case "search":
                // this.setState({ SwitchSearchDoc: true });
                //ชื่อ
                this.setState({ typeFullScreenDialogs: e })
                //open
                this.setState({ openFullScreenDialogs: true })
                //title
                this.setState({ titleFullScreenDialogs: "บันทึกจ่ายเงินมัดจำ" })
                break;
            case "Inputmultipletax":
                this.openDialog(e)
                break;
            case "Payrecord":
                this._saveConnection()
                break;
            default:
                break;
        }
    }
    SELECTPROJECT = (cell, row, enumObject, rowIndex) => {
        var btnShow = "";
        if (row.T_Code) {
            btnShow = (
                <div>
                    <SelectDatas
                        origin="PROJECT"  // ประเภท
                        valueSelect={e => this.SelectSetData("PROJECT", e, String(rowIndex))} // รับค่ากลับ
                        title="-"
                        defaultselect={row.PROJECT}// ค่าเริ่มต้นของ ประเภทราคา
                        opentitle={true}
                    />
                </div >
            )
        }
        return <div>{btnShow}</div>;
    };
    render() {
        const cellEditProp = {
            mode: 'click',
            blurToSave: true,
            afterSaveCell: this.afterSaveCell,
        };
        return (
            <div className="PSApp" onClick={this.onClick} onKeyDown={this.onKeyDown} onChange={this.onChange} onBlur={this.onBlur}>
                <Backdrop open={this.state.openBackdrop} />
                <FullScreenDialog open={this.state.openFullScreenDialogs} title={this.state.titleFullScreenDialogs} closeDialog={e => this.CloseDialog(e)}>
                    {this.state.typeFullScreenDialogs === "Payrecord" ?
                        <PopUpSaveMoneyExp closePopup={e => this.CloseDialog(e)}
                            AmountPayable={this.state.AmountPayable}
                            date={this.state.Docdate}
                            Customer={this.CustomerCode.current.value}
                            from="CSARCNDEPOSIT"
                            get_PopUpSaveMoney={this.get_PopUpSaveMoney}
                            pms="R|1|1|1|1|1|1"
                            recheckeddata={this.state.recheckeddata}
                            depositpayment={"0"}
                        /> : null}
                    {this.state.typeFullScreenDialogs === "Inputmultipletax" ?
                        // <PopUpMultipletax parm={this.state.dataMultipletax} resdata={e => this.ReturnData(e)} />
                        <PopUpMultipletax parm={this.state.dataMultipletax}
                            resdata={e => this.ReturnData(e)}
                            closePopup={e => console.log("closePopup consolee", e)}
                            recheckeddata={this.state.recheckeddata}
                            taxgroup={this.state.taxgroup}
                            from="CSARCNDEPOSIT"
                        />
                        : null}
                    {this.state.typeFullScreenDialogs === "Search_ARCode" ?
                        <PopupArcode closePopup={e => this.CloseDialog(e)} Get_PopUparcode={this.Get_PopUparcode} /> : null}
                    {this.state.typeFullScreenDialogs === "Groupdata" || this.state.typeFullScreenDialogs === "Department" || this.state.typeFullScreenDialogs === "Branch" ?
                        <PopUpOther closePopup={e => this.CloseDialog(e)}
                            type={this.state.typeFullScreenDialogs}
                            Get_PopUpOther={this.Get_PopUpOther}
                            userSite={this.state.siteCodeUser}
                            from="CSARCNDEPOSIT" /> : null}
                    {this.state.typeFullScreenDialogs === "search" ?
                        <Rechecked Dataselect={e => this._reCHK(e)} from="CSARCNDEPOSIT" />

                        : null}
                    {this.state.typeFullScreenDialogs === "T_Expcode" ?
                        <PopUptable Get_PopUpOther2={this.Get_PopUpOther2} type={this.state.typeFullScreenDialogs} from="CSARCNDEPOSIT" /> : null}
                    {this.state.typeFullScreenDialogs === "Departmenttb" || this.state.typeFullScreenDialogs === "Branchtb" ?
                        <PopUpOtherDB closePopup={e => this.CloseDialog(e)} Get_PopUpOther={this.Get_PopUpDB} type={this.state.PopUpTYpe} userSite={this.state.siteCodeUser} from="CSARCNDEPOSIT" /> : null}
                    {this.state.typeFullScreenDialogs === "Depositno" ? <PopUpOther3 Get_PopUpOther3={this.Get_PopUpOther3} type={this.state.typeFullScreenDialogs} Data={""} TAXTYPE={this.state.PriceType_code} ARCODE={this.CustomerCode.current.value} from="CSARCNDEPOSIT" /> : null}
                </FullScreenDialog>
                {this.state.showform ?
                    <PopUpReport close={this.switchshowform} url={this.state.urlsend} /> : null}
                <Topbar
                    listmenu={listMenu}
                    title="บันทึกจ่ายคืนเงินมัดจำ"
                    onClick={e => this.onClickTopbar(e)}
                />
                <div className="PSAppfrom">
                    <Grid>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <Row className="show-grid">
                                <Col xs={12} sm={4} md={4} lg={4}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon"> รหัสลูกหนี้  </span>
                                                <input id="CustomerCode" type="text" className="form-control " name="CustomerCode" ref={this.CustomerCode} />
                                                <span id="iconCustomerCode" className="input-group-addon icon" onClick={() => this.openDialog("Search_ARCode")}>
                                                    <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                                                </span>
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                                <Col xs={12} sm={8} md={8} lg={8}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span id="iconCustomerName" className="input-group-addon icon"><i className="fas fa-user"></i></span>
                                                <input id="CustomerName" type="text" className="form-control " ref={this.CustomerName} name="CustomerName" />
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                                <Col xs={12} sm={4} md={4} lg={4}>
                                    <Row className="show-grid">
                                        <MaterialUIPickers title="วันที่เอกสาร"
                                            DateValue={e => this.SelectSetData("Calendar1", e)}
                                            defaultdate={this.state.Docdate}
                                            open={this.state.checkenableInput['DOCDATE']} />
                                    </Row>
                                </Col>
                                <Col xs={12} sm={4} md={4} lg={4}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon"> กลุ่มข้อมูล  </span>
                                                <input type="text" ref={this.Groupdata_code} hidden />
                                                <input id="Groupdata" type="text" className="form-control " name="Groupdata" ref={this.Groupdata} />
                                                <span id="Groupdata" className="input-group-addon icon" onClick={() => this.openDialog("Groupdata")}>
                                                    <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                                                </span>
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                                <Col xs={12} sm={4} md={4} lg={4}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon"> เลขที่เอกสาร  </span>
                                                <input id="DeliNumber" type="text" className="form-control "
                                                    name="DeliNumber" ref={this.DeliNumber}
                                                    readOnly={this.state.OpenTAXNO} />
                                                <span id="iconTaxNumber" className="input-group-addon icon">
                                                    <i className="fas fa-sync-alt" onClick={() => this.Chackdoc()}></i>
                                                </span>
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                                <Col xs={12} sm={8} md={8} lg={8}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon"> หมายเหตุ  </span>
                                                <input id="Remark" type="text" className="form-control " name="Remark" ref={this.Remark} />
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                                <Col xs={12} sm={4} md={4} lg={4}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="form-group input-group col-xs-12 col-sm-12 col-md-12 col-lg-12 ">
                                                <span className="input-group-addon"> ใบรับเงินมัดจำ  </span>
                                                <input id="Depositno" type="text" className="form-control " name="Depositno" ref={this.Depositno} />
                                                <span id="Docgroup2" className="input-group-addon icon" onClick={() => this.openDialog("Depositno")}>
                                                    <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                                                </span>
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Grid>
                </div>
                <div className="PSAppTable">
                    <div className="form-group col-md-12">
                        <div className="form-row">
                            <BootstrapTable
                                //bordered={ false }
                                data={this.state.tableData}
                                cellEdit={cellEditProp}
                                //selectRow={ selectRowProp }
                                options={{
                                    noDataText: "...",
                                    onRowClick: this.onRowClick,
                                }}
                                trClassName='trClassName'
                                tableHeaderClass='trClassName'
                                //keyBoardNav={keyBoardNav}
                                //keyBoardNav={{enterToEdit: true}}
                                height='400'>
                                <TableHeaderColumn row='0' dataAlign="center">  <div onClick={this.deleterowall.bind(null, "", "ALL")}> <i style={{ fontSize: '16px', marginTop: '5px' }} className={this.state.CSdelete}> </i> </div>  </TableHeaderColumn>
                                <TableHeaderColumn row='1' width="45" dataField='li' editable={false} dataAlign="center" dataFormat={this.selectRowData.bind(this)} >   </TableHeaderColumn>

                                <TableHeaderColumn row='0' colSpan='2' dataAlign="center" > รหัส </TableHeaderColumn>
                                <TableHeaderColumn row='1' dataField='T_Code' width="200" editable={true} dataAlign="left" columnTitle>   </TableHeaderColumn>
                                <TableHeaderColumn row='1' dataField='BTN_Code' width="30" editable={false} dataAlign="left" dataFormat={this._cellButton.bind(this)} columnClassName='columnClassNameFormat1' hidden={this.state.C1_hiden}  ></TableHeaderColumn>

                                <TableHeaderColumn row='0' dataAlign="center"> รายการ <i id="iconincome" style={{ fontSize: "10px" }}></i></TableHeaderColumn>
                                <TableHeaderColumn row='1' dataField='T_List' width="15%" editable={false} columnTitle  >  </TableHeaderColumn>

                                <TableHeaderColumn row='0' dataAlign="center"> อธิบายเพิ่มเติม </TableHeaderColumn>
                                <TableHeaderColumn row='1' dataField='T_Explain' width="12%" editable={this.state.col} columnTitle >  </TableHeaderColumn>

                                <TableHeaderColumn row='0' dataAlign="center" > จำนวนเงิน </TableHeaderColumn>
                                <TableHeaderColumn row='1' dataField='T_Amount' width="100" editable={this.state.col} dataAlign="right" columnTitle >  </TableHeaderColumn>

                                <TableHeaderColumn row='0' colSpan='2' width="110" dataAlign="center"> แผนก  <i id="icondepartment" style={{ fontSize: "10px" }}></i></TableHeaderColumn>
                                <TableHeaderColumn row='1' dataField='T_Department' width="80" editable={this.state.col} dataAlign="left" columnTitle>  </TableHeaderColumn>
                                <TableHeaderColumn row='1' dataField='BTN_Department' width="30" editable={false} dataAlign="left" dataFormat={this._cellButton2.bind(this)} columnClassName='columnClassNameFormat1' hidden={this.state.C5_hiden}></TableHeaderColumn>
                                <TableHeaderColumn dataField='T_Department_Code' editable={false} width="30" hidden > Department Code </TableHeaderColumn>
                                <TableHeaderColumn row="0" rowSpan="2" dataField="PROJECT" editable={false} dataAlign="center" dataFormat={this.SELECTPROJECT.bind(this)} width="150"><div align="center"> โครงการ </div></TableHeaderColumn>
                                <TableHeaderColumn row='0' colSpan='2' width="130" dataAlign="center"> สาขา <i id="t_sitecode" style={{ fontSize: "10px" }}></i></TableHeaderColumn>
                                <TableHeaderColumn row='1' dataField='T_Branch' width="100" editable={this.state.col} dataAlign="left">  </TableHeaderColumn>
                                <TableHeaderColumn row="0" dataField='T_Branch_Code' editable={false} hidden> Branch Code </TableHeaderColumn>
                                <TableHeaderColumn row='1' dataField='BTN_Branch' width="30" editable={false} dataAlign="left" dataFormat={this._cellButton3.bind(this)} columnClassName='columnClassNameFormat1' hidden={this.state.C6_hiden}> </TableHeaderColumn>
                                <TableHeaderColumn row="0" dataField="BTN_T" editable={false} rowSpan='2' dataAlign="center" width="40" dataFormat={this.cellcheckT.bind(this)} > T </TableHeaderColumn>
                                <TableHeaderColumn row="0" dataField='T_C0' editable={false} dataAlign="center" hidden isKey> ฺฺC0 </TableHeaderColumn>
                                <TableHeaderColumn row="0" dataField='T_SB' editable={false} hidden>SB </TableHeaderColumn>
                                <TableHeaderColumn row="0" dataField="T_tCode" editable={false} hidden>tCode  </TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                    </div>
                </div>
                <div className='clearfix'> <hr></hr></div>
                {/* <div className="PSAppfrom"> */}
                <Grid>
                    <Col xs={12} sm={8} md={8} lg={8}>
                        <Row className="show-grid">
                            <Col xs={12} sm={6} md={6} lg={6}>
                                <Row className="show-grid">
                                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'  >
                                        <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                            <span className="input-group-addon"> พนักงาน  </span>
                                            <input type="text" className="form-control hidden" ref={this.Csuser_code} />
                                            <input id="Csuser" type="text" className="form-control " name="Csuser" ref={this.Csuser} readOnly />
                                            <span id="spanCsuser" className="input-group-addon icon" onClick={() => this.onAddValue("Csuser", this.state.userCode)}>
                                                <i className="fas fa-sync-alt" ></i>
                                            </span>
                                        </div>
                                    </div>
                                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12' >
                                        <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                            <span className="input-group-addon"> แผนก  </span>
                                            <input type="text" className="form-control hidden" ref={this.Department_code} />
                                            <input id="Department" type="text" className="form-control " name="Department" ref={this.Department} />
                                            <span id="Department1" className="input-group-addon icon" onClick={() => this.openDialog("Department")}>
                                                <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <SelectDatas
                                                origin="PROJECT"  // โครงการ
                                                valueSelect={e => this.SelectSetData("PROJECT", e, "")} // รับค่ากลับ
                                                title="โครงการ"
                                                defaultselect={this.state.PROJECT}// ค่าเริ่มต้นของ โครงการ
                                            />
                                        </div>
                                    </div>
                                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'  >
                                        <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                            <span className="input-group-addon">  สาขา  </span>
                                            <input type="text" className="form-control hidden" ref={this.Branch_code} />
                                            <input id="Branch" type="text" className="form-control " name="Branch" ref={this.Branch} />
                                            <span id="sitecode1" className="input-group-addon icon" onClick={() => this.openDialog("Branch")} >
                                                <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                                            </span>
                                        </div>
                                    </div>
                                </Row>
                            </Col>
                            <Col xs={12} sm={6} md={6} lg={6}>
                                <Row className="show-grid">
                                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'  >
                                        <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                            <SelectDatas
                                                origin="PriceType"  // ประเภท
                                                valueSelect={e => this.SelectSetData("PriceType", e)} // รับค่ากลับ
                                                title="ประเภทราคา"
                                                defaultselect={this.state.defaultselect}// ค่าเริ่มต้นของ ประเภทราคา
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12" >
                                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <span className="input-group-addon">สกุลเงิน  </span>
                                            <input type="text" className="form-control" ref={this.Currency} />
                                        </div>
                                    </div>
                                    <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12" >
                                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <span className="input-group-addon">อัตราแลกเปลี่ยน  </span>
                                            <input type="text" className="form-control Price" value="1.0000000" readOnly />
                                        </div>
                                    </div>

                                </Row>
                            </Col>
                            <Col xs={12} sm={6} md={6} lg={6}>
                                <Row className="show-grid">

                                </Row>
                            </Col>
                            <Col xs={12} sm={6} md={6} lg={6}>
                                <Row className="show-grid">

                                </Row>
                            </Col>
                            <Col xs={12} sm={6} md={6} lg={6}>
                                <Row className="show-grid">

                                </Row>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} sm={4} md={4} lg={4}>
                        <Row className="show-grid">
                            <Col xs={12} sm={12} md={12} lg={12}>
                                <Row className="show-grid">
                                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                        <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                            <span className="input-group-addon "> รวมจำนวนเงิน  </span>
                                            <input id="Sumamount1" type="text" className="form-control Price" name="Sumamount1" value={this.state.Sumamount1} ref={this.Sumamount1} disabled />
                                        </div>
                                    </div>
                                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                        <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                            <span className="input-group-addon  "> ภาษีมูลค่าเพิ่ม  </span>
                                            <input id="Taxrate" type="text" className="form-control Price" ref={this.Taxrate} name="Taxrate"
                                                onClick={(e) => { e.target.value = parseFloat(e.target.value).toFixed(0); }}
                                                onKeyDown={this.Cal_Price1}
                                                onBlur={this.Cal_Price.bind(null)} />
                                            <span className="input-group-addon icon"> % </span>
                                            <input id="Taxamount" type="text" className="form-control Price" ref={this.Taxamount} name="Taxamount" value={this.state.Taxamount} disabled />
                                        </div>
                                    </div>
                                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                        <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                            <span className="input-group-addon"> มูลค่ารวมภาษี  </span>
                                            <input id="Totalamount" type="text" className="form-control Price" ref={this.Totalamount} name="" value={this.state.Totalamount} disabled />
                                        </div>
                                    </div>
                                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                        <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                            <span className="input-group-addon  "> มูลค่ายกเว้น  </span>
                                            <input id="Sumamount2" type="text" className="form-control Price" ref={this.Sumamount2} name="" value={this.state.Sumamount2} disabled />
                                        </div>
                                    </div>
                                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                        <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                            <span className="input-group-addon  "> เงินรวมทั้งสิ้น  </span>
                                            <input id="Debtamount" type="text" className="form-control Price" ref={this.Debtamount} name="Debtamount" value={this.state.Debtamount} disabled />
                                        </div>
                                    </div>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={12}>
                        <Row className="show-grid">
                            <Col xs={12} sm={12} md={12} lg={12}>
                                <Panel>
                                    <Panel.Heading>
                                        <Panel.Title componentClass="h5">ข้อมูลเพิ่มเติม ( User's Field) </Panel.Title>
                                    </Panel.Heading>
                                    <Panel.Body>
                                        <Col xs={12} sm={12} md={12} lg={12} >
                                            <Row className="show-grid">
                                                <Col xs={12} sm={12} md={12} lg={4}>
                                                    <div className="row ">
                                                        <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                            <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                                <span className="input-group-addon "> รอบที่ </span>
                                                                <input type="number" className="form-control Price" name="Round_PAY" ref={this.Round_PAY} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Panel.Body>
                                </Panel>
                            </Col>
                        </Row>
                    </Col>
                </Grid>
                <Snackbar place="br"
                    color={this.state.color}
                    icon={this.state.icon}
                    autoClose={this.state.autoClose}
                    message={this.state.messagealert}
                    open={this.state.opensnackbar}
                    closeNotification={() => { this.setState({ opensnackbar: false }) }}
                    close />
            </div>
        );
    }
}
